import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/components/feature/SectionHeading";
import { recruitSelectionFlow } from "@/mocks/legalPages";

/**
 * 採用ページ SELECTION FLOW。
 * 既存サイトのFLOWデザイン（罫線グリッド）を流用し、PC 3列×2段 / スマホ 縦方向で表示する。
 */
export default function RecruitFlow() {
  return (
    <section className="bg-background-50 py-20 md:py-28 lg:py-32">
      <div className="u-container">
        <Reveal>
          <SectionHeading en={recruitSelectionFlow.en} jp={recruitSelectionFlow.heading} />
        </Reveal>

        <Reveal delay={120}>
          <ol className="mt-12 grid grid-cols-1 gap-px overflow-hidden border border-foreground-950/12 bg-foreground-950/12 sm:grid-cols-2 md:mt-16 lg:grid-cols-3">
            {recruitSelectionFlow.steps.map((step) => (
              <li key={step.no} className="flex flex-col bg-background-50 p-7 md:p-8">
                <span className="font-label text-[12px] tracking-[0.25em] text-secondary-600">
                  {step.no}
                </span>
                <h3 className="mt-7 font-heading text-[16px] text-foreground-950 md:text-[17px]">
                  {step.title}
                </h3>
                {step.note ? (
                  <p className="mt-3 text-[12px] leading-[1.9] text-foreground-600">{step.note}</p>
                ) : null}
              </li>
            ))}
          </ol>
        </Reveal>
      </div>
    </section>
  );
}